<template>
  <div>
    <h2 class="text-secondary-500">
      Task Status Export
    </h2>
    <div class="flex flex-wrap -mx-5">
      <d-field label="From Due Date" class="w-full md:w-1/2 px-5 mb-5">
        <d-datepicker v-model="fromDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
      </d-field>

      <d-field label="To Due Date" class="w-full md:w-1/2 px-5 mb-5">
        <d-datepicker v-model="toDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
      </d-field>

      <d-field label="Assignment/Task Name" class="w-full md:w-1/2 px-5 mb-5">
        <d-input v-model="todoName" placeholder="Full or partial match" />
      </d-field>

      <d-field>
        <d-checkbox v-model="incompleteOnly" class="w-full md:w-1/2 px-5 mb-5">
          Only Incomplete Assignments/Tasks
        </d-checkbox>
      </d-field>

      <d-field>
        <d-checkbox v-model="includeClosed" class="w-full px-5 mb-5">
          Include Closed Tasks
        </d-checkbox>
      </d-field>

      <d-field>
        <d-checkbox v-model="includeArchived" class="w-full px-5 mb-5">
          Include Archived Assignments
        </d-checkbox>
      </d-field>

      <d-field>
        <d-checkbox v-model="includeSubmissionInfo" class="w-full px-5 mb-5">
          Include Submission Info
        </d-checkbox>
      </d-field>

      <div class="w-full px-5 mt-5">
        <d-btn :loading="fetchingReport" @click="handleSubmit">
          <d-icon icon="download" color="white" class="mr-2" /> Download Report
        </d-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import axios from 'axios';

  export default {
    parent: true,

    data() {
      return {
        fetchingReport: false,
        fromDate: dayjs().subtract('30', 'day').format('MM/DD/YYYY'),
        toDate: dayjs().format('MM/DD/YYYY'),
        incompleteOnly: false,
        includeClosed: false,
        includeArchived: false,
        includeSubmissionInfo: false,
        todoName: '',
        selectedCustomerId: null,
        customers: [],
        ratingsReports: [],
        total: 0,
        pagination: {
          page: 1,
          pageSize: 50,
          sortField: 'createdAt',
          sortOrder: 'asc',
        },
        loading: false,
        loadingTable: false,
      };
    },
    watch: {
    },

    mounted() {
    },
    methods: {
      async handleSubmit() {
        const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

        const params = [`fromDate=${dayjs(this.fromDate).format('MM/DD/YYYY')}`, `toDate=${dayjs(this.toDate).format('MM/DD/YYYY')}`, `timeZone=${timeZone}`, `todoName=${this.todoName}`, `incompleteOnly=${this.incompleteOnly}`, `includeClosed=${this.includeClosed}`, `includeArchived=${this.includeArchived}`, `includeSubmissionInfo=${this.includeSubmissionInfo}`].join('&');
        this.fetchingReport = true;
        try {
          const { data } = await axios.get(`/reports/todo-items/excel?${params}`, {
            responseType: 'blob',
          });
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `TodoReport_${dayjs(this.fromDate).format('MM-DD-YYYY')}_${dayjs(this.toDate).format('MM-DD-YYYY')}.xlsx`);
          document.body.appendChild(link);
          link.click();
        } catch (error) {
            const errorObj = await error.response.data.text();
            this.$toast.error(errorObj);
       } finally {
          this.fetchingReport = false;
        }
      },    
    },
  };
</script>